import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Heading as TRHeading, Icon } from '@planningcenter/tapestry-react'
import Link from './link'

function Heading({ anchored, ...props }) {
  return anchored ? (
    <AnchoredHeading anchored={anchored} {...props} />
  ) : (
    <BaseHeading {...props} />
  )
}

Heading.propTypes = {
  anchored: PropTypes.bool,
  id: (props, propName, componentName) => {
    return props.anchored
      ? PropTypes.checkPropTypes(
          { id: PropTypes.string.isRequired },
          props,
          propName,
          componentName
        )
      : null
  },
  props: PropTypes.any,
}

export default Heading

const ANCHOR_REGEX = /(#).+#([^?]+)/

const currentAnchor = () => {
  const matches = window.location.hash.match(ANCHOR_REGEX)
  return matches ? matches[2] : null
}

const href = id => {
  const hashRoute = window.location.hash.split('#')[1]
  return hashRoute ? `#${hashRoute}#${id}` : `#${id}`
}

function AnchoredHeading({ anchored, id, ...props }) {
  const [hover, setHover] = useState(false)
  const ref = useRef(null)
  const anchor = currentAnchor()

  useEffect(() => {
    ref.current &&
      anchor === id &&
      ref.current.scrollIntoView({ behavior: 'smooth' })
  }, [anchor, id])

  return (
    <Link
      ref={ref}
      id={id}
      to={href(id)}
      underline={false}
      style={{ color: props.color || 'black', display: 'flex', alignItems: 'center' }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <BaseHeading marginRight={1} {...props} />
      <Icon name="general.link" size="lg" opacity={hover ? 1 : 0} />
    </Link>
  )
}

function BaseHeading(props) {
  return <TRHeading size={2} color="black" weight={600} {...props} />
}
